// A focus-ring offset that only the always theme turns on (NO-791). Under the
// theme the ring is olive, and so are the primary Button, Checkbox, RadioGroup
// and Slider thumb, so a ring flush against them disappears. The offset width
// reads --focus-ring-offset, which only [data-theme="always"] defines; the
// classic width stays 0px, so nothing moves for Admin and Booking.
export const FOCUS_RING_OFFSET =
  "ring-offset-background focus-visible:ring-offset-(length:--focus-ring-offset,0px)";
